import {
  ArrowDropDown,
  ArrowDropUp,
  DeleteOutline,
  Domain,
  EditOutlined,
  GroupAdd,
  LibraryAdd,
  Add,
  Clear,
} from "@mui/icons-material";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  Collapse,
  Checkbox,
  Dialog,
  Tab,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { Field, Form, Formik, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { color } from "../../../../StyleData/Config";
import ErrorProps from "../../../../Component/Errorprops";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  DatePicker,
  LocalizationProvider,
  renderTimeViewClock,
  DateTimePicker,
} from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fromUTC, toUTC, getDateWithOutUTC } from "../../../../utils/dateUtil";

const Task = ({ workOrderId, handleCloseClick, mode, editData }) => {
  const [loading, setLoading] = useState(false);

  const [taskTypeSelect, setTaskTypeSelect] = useState(
    mode === "Edit" ? editData.taskTypeName : "",
  );
  const [taskTypeList, setTaskTypeList] = useState([]);
  const [meter, setMeter] = useState([]);
  const [open, setOpen] = useState(false);
  const [multipleChoice, setMultipleChoice] = useState(
    mode === "Edit"
      ? editData.listOfChoices !== undefined
        ? editData.listOfChoices
        : []
      : [],
  );
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);

  const convertToHHMM = (decimalHours) => {
    if (!decimalHours) return "";
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  const convertToHours = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours + minutes / 60;
  };

  const validationSchema = Yup.object({
    taskDuration: Yup.string()
      .required("This field is required")
      .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
  });

  useEffect(() => {
    console.log(workOrderId, "cehcj");

    getTaskList();
  }, []);

  const getTaskList = async () => {
    setLoading(true);
    const taskTypeListLink = masterAPI["selectList"].taskTypes;
    await axiosPrivate
      .get(`${taskTypeListLink}`)
      .then((res) => {
        console.log(res);
        setTaskTypeList(res.data);
      })
      .catch((e) => {
        setTaskTypeList([]);
        console.log(e, "createWoTask error");
      });

    //    const assetMeter=masterAPI["meter"].getMeterByAsset
    //         await axiosPrivate.get(`${assetMeter}/${res.data.result.assetId}`).then(res=>{

    //            setMeter(res.data.result)
    //          }).catch(e=>{
    //            setMeter([])
    //            console.log(e,"error")
    //          })
    setLoading(false);
  };

  const onSubmit = async (values, { resetForm }) => {
    const createLink = masterAPI["workOrderTask"].create;
    const updateLink = masterAPI["workOrderTask"].update;
    if (mode === "Edit") {
      const putData = {
        id: editData.id,
        listOfChoices: multipleChoice,
        listOfSelectedChoices: multipleChoice,
        isMultipleChoice: true,
        ...values,
        taskDuration: convertToHours(values.taskDuration),
        targetStartDate: values.targetStartDate
          ? toUTC(values.targetStartDate).utcISOString
          : values.targetStartDate,
        targetEndDate: values.targetEndDate
          ? toUTC(values.targetEndDate).utcISOString
          : values.targetEndDate,
        plannedStartDate: values.plannedStartDate
          ? toUTC(values.plannedStartDate).utcISOString
          : values.plannedStartDate,
        plannedEndDate: values.plannedEndDate
          ? toUTC(values.plannedEndDate).utcISOString
          : values.plannedEndDate,
        actualStartDate: values.actualStartDate
          ? toUTC(values.actualStartDate).utcISOString
          : values.actualStartDate,
        actualEndDate: values.actualEndDate
          ? toUTC(values.actualEndDate).utcISOString
          : values.actualEndDate,
      };
      await axiosPrivate
        .put(`${updateLink}`, putData)
        .then((res) => {
          console.log(res);

          setTaskTypeSelect("");
          setMultipleChoice([]);
          handleCloseClick();
        })
        .catch((e) => {
          console.log(e, "update Task");
        });
    } else {
      const postData = {
        ...values,
        taskDuration: convertToHours(values.taskDuration),
        listOfChoices: multipleChoice,
        listOfSelectedChoices: multipleChoice,
        isMultipleChoice: multipleChoice.length === 0 ? false : true,
        targetStartDate: values.targetStartDate
          ? toUTC(values.targetStartDate).utcISOString
          : values.targetStartDate,
        targetEndDate: values.targetEndDate
          ? toUTC(values.targetEndDate).utcISOString
          : values.targetEndDate,
        plannedStartDate: values.plannedStartDate
          ? toUTC(values.plannedStartDate).utcISOString
          : values.plannedStartDate,
        plannedEndDate: values.plannedEndDate
          ? toUTC(values.plannedEndDate).utcISOString
          : values.plannedEndDate,
        actualStartDate: values.actualStartDate
          ? toUTC(values.actualStartDate).utcISOString
          : values.actualStartDate,
        actualEndDate: values.actualEndDate
          ? toUTC(values.actualEndDate).utcISOString
          : values.actualEndDate,
      };
      console.log(postData);
      await axiosPrivate
        .post(`${createLink}`, postData)
        .then((res) => {
          console.log(res);
          handleCloseClick();
          setTaskTypeSelect("");
          setMultipleChoice([]);
          resetForm();
        })
        .catch((e) => {
          console.log(e, "create Task");
        });
    }
  };

  const initialValue = {
    taskName: mode === "Edit" ? editData.taskName : "",
    taskNo: mode === "Edit" ? editData.taskNo : "",
    sequenceNo: mode === "Edit" ? editData.sequenceNo : "",
    description: mode === "Edit" ? editData.description : "",
    taskDuration: mode === "Edit" ? convertToHHMM(editData.taskDuration) : "",
    taskTypeId: mode === "Edit" ? editData.taskTypeId : "",

    actualStartDate:
      mode === "Edit"
        ? editData.actualStartDate
          ? fromUTC(editData.actualStartDate).tzString
          : null
        : null,
    actualEndDate:
      mode === "Edit"
        ? editData.actualEndDate
          ? fromUTC(editData.actualEndDate).tzString
          : null
        : null,
    targetStartDate:
      mode === "Edit"
        ? editData.targetStartDate !== null &&
          editData.targetStartDate !== undefined
          ? fromUTC(editData.targetStartDate).tzString
          : null
        : null,
    targetEndDate:
      mode === "Edit"
        ? editData.targetEndDate !== null &&
          editData.targetEndDate !== undefined
          ? fromUTC(editData.targetEndDate).tzString
          : null
        : null,
    plannedStartDate:
      mode === "Edit"
        ? editData.plannedStartDate
          ? fromUTC(editData.plannedStartDate).tzString
          : null
        : null,
    plannedEndDate:
      mode === "Edit"
        ? editData.plannedEndDate
          ? fromUTC(editData.plannedEndDate).tzString
          : null
        : null,
    workOrderId: workOrderId,
    meterId: mode === "Edit" ? editData.meterId : null,
  };

  const handleRemoveItem = (index) => {
    const newItems = [...multipleChoice];
    newItems.splice(index, 1);
    setMultipleChoice(newItems);
  };

  return (
    <Box>
      <Grid container gap={"1rem"}>
        <Grid
          item
          xs={12}
          sx={{
            boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
            p: 1.5,
            backgroundColor: "white",
          }}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  color: color.masterDialogTitleColor,
                  fontSize: color.masterDialogFontSize,
                }}
              >
                {mode === "Edit" ? "Edit Task" : " Create Task"}
              </Typography>
              <IconButton onClick={handleCloseClick}>
                <Clear />
              </IconButton>
            </Box>

            <Divider
              sx={{
                border: "1px solid rgb(0 0 0 / 17%)",
                mb: "15px",
              }}
            />
          </Grid>
          {loading ? (
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Formik
              initialValues={initialValue}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize
            >
              {({ handleChange, setFieldValue, values, resetForm }) => (
                <Form>
                  <Grid container spacing={"1.5rem"}>
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        Task Name
                      </Typography>
                      <Field
                        as={TextField}
                        size={"small"}
                        type="text"
                        name="taskName"
                        placeholder="Enter Task Name"
                        fullWidth
                        sx={{
                          ".MuiInputBase-input": {
                            // letterSpacing: "0.2rem",

                            "&::placeholder": {
                              // color: "green",
                              opacity: 1,
                              color: color.placeholderColor,
                              fontSize: "13px",
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        Task No
                      </Typography>
                      <Field
                        as={TextField}
                        size={"small"}
                        type="text"
                        name="taskNo"
                        placeholder="Enter Task No"
                        fullWidth
                        sx={{
                          ".MuiInputBase-input": {
                            // letterSpacing: "0.2rem",

                            "&::placeholder": {
                              // color: "green",
                              opacity: 1,
                              color: color.placeholderColor,
                              fontSize: "13px",
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        Sequence No
                      </Typography>
                      <Field
                        as={TextField}
                        size={"small"}
                        type="text"
                        name="sequenceNo"
                        placeholder="Enter Sequence No"
                        fullWidth
                        sx={{
                          ".MuiInputBase-input": {
                            // letterSpacing: "0.2rem",

                            "&::placeholder": {
                              // color: "green",
                              opacity: 1,
                              color: color.placeholderColor,
                              fontSize: "13px",
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        Task Duration
                      </Typography>
                      <Field
                        as={TextField}
                        size={"small"}
                        type="text"
                        name="taskDuration"
                        placeholder="Enter Task Duration (HH:MM)"
                        fullWidth
                        sx={{
                          ".MuiInputBase-input": {
                            // letterSpacing: "0.2rem",

                            "&::placeholder": {
                              // color: "green",
                              opacity: 1,
                              color: color.placeholderColor,
                              fontSize: "13px",
                            },
                          },
                        }}
                      />
                      <ErrorMessage name="taskDuration">
                        {(error) => <ErrorProps>{error}</ErrorProps>}
                      </ErrorMessage>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        Task Type
                      </Typography>
                      <Field
                        as={Select}
                        // label={"Select"}
                        size={"small"}
                        type="text"
                        name="taskTypeId"
                        fullWidth
                        displayEmpty
                        MenuProps={{
                          PaperProps: { sx: { maxHeight: "40vh" } },
                        }}
                        renderValue={
                          values.taskTypeId !== ""
                            ? undefined
                            : () => (
                                <Typography
                                  sx={{
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  }}
                                >
                                  Select
                                </Typography>
                              )
                        }
                      >
                        {taskTypeList.map((id, i) => (
                          <MenuItem
                            value={id.value}
                            onClick={() => {
                              setTaskTypeSelect(id.text);
                              if (id.text.toLowerCase() === "multiple choice") {
                                setMultipleChoice([""]);
                              }
                            }}
                          >
                            {id.text}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{
                        display:
                          taskTypeSelect.toLowerCase() === "meter reading"
                            ? "default"
                            : "none",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: color.labelFontWeight,
                          mb: color.labelmb,
                          fontSize: color.labelFont,
                          color: color.labelColor,
                        }}
                      >
                        Meter
                      </Typography>
                      <Field
                        as={Select}
                        // label={"Select"}
                        size={"small"}
                        type="text"
                        name="meterId"
                        fullWidth
                        displayEmpty
                        MenuProps={{
                          PaperProps: { sx: { maxHeight: "40vh" } },
                        }}
                        renderValue={
                          values.meterId !== null
                            ? undefined
                            : () => (
                                <Typography
                                  sx={{
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  }}
                                >
                                  Select
                                </Typography>
                              )
                        }
                      >
                        {meter.map((id, i) => (
                          <MenuItem value={id.meterId}>{id.meterName}</MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      md={6}
                      sx={{
                        display:
                          taskTypeSelect.toLowerCase() === "multiple choice"
                            ? "default"
                            : "none",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Choice
                        </Typography>

                        <Add
                          sx={{ cursor: "pointer", color: color.labelColor }}
                          onClick={() => {
                            setMultipleChoice([...multipleChoice, ""]);
                          }}
                        />
                      </Box>

                      <Grid item xs={12}>
                        {multipleChoice.map((choice, i) => (
                          <Box
                            sx={{
                              display: "flex",
                              gap: "0.2rem",
                              width: "100%",
                            }}
                          >
                            <Field
                              as={TextField}
                              size={"small"}
                              type="text"
                              value={choice}
                              placeholder="Enter Choice"
                              fullWidth
                              onChange={(e) => {
                                const mcData = [...multipleChoice];
                                mcData[i] = e.target.value;
                                console.log(mcData);
                                setMultipleChoice(mcData);
                              }}
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                            <IconButton
                              onClick={() => {
                                if (multipleChoice.length !== 1) {
                                  handleRemoveItem(i);
                                }
                              }}
                            >
                              <DeleteOutline />
                            </IconButton>
                          </Box>
                        ))}
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          color: color.masterDialogTitleColor,
                          fontSize: color.masterDialogFontSize,
                        }}
                      >
                        {" "}
                        Details{" "}
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => setOpen(!open)}
                        >
                          {open ? <ArrowDropUp /> : <ArrowDropDown />}
                        </IconButton>
                      </Typography>
                      <Divider
                        sx={{
                          border: "1px solid rgb(0 0 0 / 17%)",
                          mb: "15px",
                        }}
                      />
                      <Collapse in={open} timeout="auto" unmountOnExit>
                        <Grid container spacing={"1.5rem"}>
                          <Grid item xs={12} sm={6} mb={2}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Description
                            </Typography>
                            <Field
                              as={TextField}
                              size={"small"}
                              type="text"
                              name="description"
                              placeholder="Enter Description"
                              fullWidth
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={"1.5rem"}>
                          <Grid
                            item
                            xs={12} sm={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Target Start Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DateTimePicker"]}>
                                <DateTimePicker
                                  format="DD/MM/YYYY HH:mm"
                                  ampm={false}
                                  value={
                                    values.targetStartDate !== null
                                      ? dayjs(values.targetStartDate)
                                      : values.targetStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  readOnly
                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      fullWidth: true,
                                    },
                                  }}
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        setFieldValue(
                                          "targetStartDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Grid>

                          <Grid
                            item
                            xs={12} sm={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Target End Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DateTimePicker"]}>
                                <DateTimePicker
                                  format="DD/MM/YYYY HH:mm"
                                  ampm={false}
                                  value={
                                    values.targetEndDate !== null
                                      ? dayjs(values.targetEndDate)
                                      : values.targetEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}
                                  readOnly
                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        setFieldValue(
                                          "targetEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={12} sm={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Planned Start Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DateTimePicker"]}>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.plannedStartDate !== null
                                      ? dayjs(values.plannedStartDate)
                                      : values.plannedStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        setFieldValue(
                                          "plannedStartDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={12} sm={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Planned End Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DateTimePicker"]}>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.plannedEndDate !== null
                                      ? dayjs(values.plannedEndDate)
                                      : values.plannedEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        setFieldValue(
                                          "plannedEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={12} sm={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Actual Start Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DateTimePicker"]}>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  readOnly
                                  disableOpenPicker
                                  value={
                                    values.actualStartDate !== null
                                      ? dayjs(values.actualStartDate)
                                      : values.actualStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      fullWidth: true,
                                      InputProps: {
                                        endAdornment: null,
                                      },
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        setFieldValue(
                                          "actualStartDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={12} sm={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Actual End Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DateTimePicker"]}>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  readOnly
                                  disableOpenPicker
                                  value={
                                    values.actualEndDate !== null
                                      ? dayjs(values.actualEndDate)
                                      : values.actualEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      fullWidth: true,
                                      InputProps: {
                                        endAdornment: null,
                                      },
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        setFieldValue(
                                          "actualEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Collapse>
                    </Grid>
                    <Grid container item xs={12} justifyContent={"flex-end"}>
                      <Button
                        onClick={() => {
                          handleCloseClick();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button type="submit">submit</Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Task;
